import preset1 from "./preset-1.png"
import preset2 from "./preset-2.png"
import preset3 from "./preset-3.png"
import preset4 from "./preset-4.png"

export const presetImages = [preset1, preset2, preset3, preset4]
